module.exports = __webpack_public_path__ + "img/tshirt1.41c2c652.png";